import type { ReactElement } from 'react';
import type { ProductionStep } from './production-steps';

interface ProductionStepCardProps {
  readonly order: number;
  readonly step: ProductionStep;
}

/** 단계 한 칸 — 가는 윗선 아래 큰 가는 번호, 굵은 제목, 회색 설명. 화면 제목과 같은 가는 큰 글자 결. */
export const ProductionStepCard = ({ order, step }: ProductionStepCardProps): ReactElement => (
  <li className="flex flex-col gap-4 border-t border-foreground/10 pt-5">
    <span
      aria-hidden
      className="text-[2rem] leading-none font-light tracking-[-0.03em] text-foreground/35 tabular-nums"
    >
      {String(order).padStart(2, '0')}
    </span>
    <div className="flex flex-col gap-1.5">
      <h3 className="text-[15px] font-bold tracking-[-0.01em]">
        <span className="sr-only">{order}단계 </span>
        {step.title}
      </h3>
      <p className="text-sm leading-relaxed text-muted-foreground">{step.description}</p>
    </div>
  </li>
);
